import { Theme } from '@mui/material';
import {
  PRE_LITS_PLACEHOLDER_SERVICE_LEVEL,
  ServiceLevel,
} from '@provision/service-level-utils';

/**
 * Resolves a service level (or platform SLA display string) to its `extended`
 * palette family. Returns `undefined` for levels that have no branded color
 * (Non-Member, Inactive, Warranty Essentials, unknown). Shared by both public
 * color helpers so the tier -> family mapping lives in one place.
 */
function getServiceLevelPalette(serviceLevel: string | null | undefined, theme: Theme) {
  const { extended } = theme.palette.custom.OV;

  switch (serviceLevel) {
    case ServiceLevel.Signature:
    case ServiceLevel.CPPSignature:
      return extended.Signature;

    case ServiceLevel.Proactive:
    case ServiceLevel.CPPProactive:
      return extended.Proactive;

    case ServiceLevel.Essentials:
    case ServiceLevel.EssentialsPlus:
    case ServiceLevel.CPPEssentialsPlus:
      return extended.Essentials;

    case ServiceLevel.SecurityOnly:
      return extended.SecurityOnly;

    case PRE_LITS_PLACEHOLDER_SERVICE_LEVEL:
    case ServiceLevel.Priority:
    case ServiceLevel.CPPPriority:
      return extended.Priority;

    default:
      return undefined;
  }
}

export const getServiceLevelColor = (serviceLevel: ServiceLevel, theme: Theme) => {
  const palette = getServiceLevelPalette(serviceLevel, theme);

  if (palette) {
    return { color: palette.onColorContainer, bg: palette.colorContainer };
  }

  return {
    color: theme.palette.custom.OV.sys.onSurface,
    bg: theme.palette.custom.OV.sys.surfaceContainerHighest,
  };
};

export function getServiceLevelColors(serviceLevel: string | null | undefined, theme: Theme) {
  const palette = getServiceLevelPalette(serviceLevel, theme);

  if (palette) {
    return { filled: true, color: palette.color };
  }

  switch (serviceLevel) {
    case ServiceLevel.Inactive:
      return { filled: true, color: theme.palette.custom.OV.sys.outline };

    case ServiceLevel.NonMember:
    case ServiceLevel.WarrantyEssentials:
      return { filled: false, color: theme.palette.custom.OV.sys.outline };

    default:
      return { filled: false, color: '' };
  }
}
